import cn from "classnames";

import type { ReasonsToBuySection as RTBs } from "@/sanity.types";

import { ReasonsToBuyItem } from "./reasonsToBuyItem.component";

export const ReasonsToBuySection = ({ block }: ReasonsToBuySectionProps) => {
  const renderRTBs = () => {
    if (!block.reasons || !block.reasons.length) return null;
    return block.reasons.map((reason, index) => (
      <ReasonsToBuyItem
        key={index}
        title={reason.title}
        description={reason.description}
        icon={reason?.icon}
      />
    ));
  };
  return (
    <section
      className={cn(
        "container mx-auto my-9 grid grid-cols-1 gap-9 lg:grid-cols-3 lg:gap-8",
      )}>
      {renderRTBs()}
    </section>
  );
};

export type ReasonsToBuySectionProps = {
  block: RTBs;
};
